import { ReactNode } from "react";
import * as Dialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import cn from "clsx";

// SideDrawer — rechts angeschlagenes Panel mit Overlay, Esc + Focus-Trap (Radix).
// Kopf (Eyebrow + Titel + Schliessen), scrollbarer Body, optionaler Footer-Slot.
// Konsumiert nur Tokens (Flaechen/Border/Radius/Font).
export interface SideDrawerProps {
  open: boolean;
  onClose: () => void;
  eyebrow?: ReactNode;
  title?: ReactNode;
  footer?: ReactNode;
  /** Breite (default 420px). */
  className?: string;
  children: ReactNode;
}

export function SideDrawer({ open, onClose, eyebrow, title, footer, className, children }: SideDrawerProps) {
  return (
    <Dialog.Root open={open} onOpenChange={(o) => !o && onClose()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/30 z-40 animate-fade-in" />
        <Dialog.Content
          aria-describedby={undefined}
          className={cn(
            "fixed top-0 right-0 h-full w-[420px] max-w-[92vw] z-50",
            "bg-surface border-l border-border shadow-2xl flex flex-col",
            "animate-slide-in-right focus:outline-none",
            className,
          )}
        >
          <div className="relative shrink-0 px-5 py-4 border-b border-border">
            {eyebrow && (
              <div className="text-[0.66rem] font-semibold uppercase tracking-[0.06em] text-text-3">{eyebrow}</div>
            )}
            <Dialog.Title className="font-numeric text-lg font-semibold leading-snug text-text mt-1 pr-9">
              {title}
            </Dialog.Title>
            <Dialog.Close
              className="absolute top-3.5 right-3.5 w-8 h-8 grid place-items-center rounded-control border border-border bg-surface text-text-2 hover:bg-surface-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-500"
              aria-label="Schließen"
            >
              <X className="w-4 h-4" />
            </Dialog.Close>
          </div>
          <div className="flex-1 overflow-y-auto px-5 py-4">{children}</div>
          {footer && (
            <div className="shrink-0 px-5 py-3.5 border-t border-border flex items-center gap-2.5">{footer}</div>
          )}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}

export default SideDrawer;
